import { createContext, useContext } from "react";

export type QualityLevel = {
  id: number;
  label: string;
};

export type CurrentQualityLevel = {
  id: number;
  isAuto: boolean;
};

export type VideoSourceState = {
  duration: number;
  setQualityLevel?: (id: number) => void;
  qualityLevels?: QualityLevel[];
  currentQualityLevel?: CurrentQualityLevel;
};

export const VideoSourceContext = createContext<VideoSourceState | undefined>(
  undefined
);

export const useVideoSource = () => {
  const context = useContext(VideoSourceContext);

  if (context === undefined) {
    throw new Error(
      "useVideoSource must be used within a VideoSourceProvider provider."
    );
  }

  return context;
};
